import { render, staticRenderFns } from "./MarkedOrdersTab.vue?vue&type=template&id=431c1733&scoped=true"
import script from "./MarkedOrdersTab.vue?vue&type=script&lang=js"
export * from "./MarkedOrdersTab.vue?vue&type=script&lang=js"
import style0 from "./MarkedOrdersTab.vue?vue&type=style&index=0&id=431c1733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431c1733",
  null
  
)

export default component.exports